import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"


const Notification = ({ title, description, day, month, link }) => {
  return (
    <>
      <a href={link} target={"_blank"} style={{ textDecoration: "none" }}>
        <Wrapper>
          <DateWrapper><Date><p>{day}<br />{month}</p></Date></DateWrapper>
          <LinkWrapper>
            <Title>{title}</Title>
            <Description>{description}</Description>
          </LinkWrapper>
        </Wrapper>
      </a>
    </>
  );
}


Notification.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  day: PropTypes.number.isRequired,
  month: PropTypes.string.isRequired,
};

// ********** Styled Components ********** //


let Wrapper = styled.div`

  // Margin & Padding
  margin: 0 0 var(--spacer-3) 0;
  padding:  0; // TODO Check
  
  background-color: var(--primaryWhite);
  
  border-radius: 3px;
  
  overflow: hidden;
  
  box-shadow: 0 0 2px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.15);
  
  // Sizing
  width: 100%;
  
  // Flexbox
  display: flex;
  flex-direction: row;
  
  transition: all 0.15s ease-in;

  :hover {
    z-index: 100;
    box-shadow:  0 3px 4px 0 rgba(0,0,0,0.18), 0 3px 4px 0 rgba(0,0,0,0.15);
  }
`;

//  - Created on July 9, 2020
const DateWrapper = styled.div`

    // Flexbox
  display: flex;
  align-items: center;
  justify-content: center;
  
  
`;

const Date = styled.div`

  height: 100%;
  
  // Margin & Padding
  margin: 0;
  padding: 0 var(--spacer-3);
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  // Border
  //border: 2px solid var(--primaryRed);
  background-color: var(--primaryRedHover);
  
  p {
  
    // Margin & Padding
    margin: 0;
    padding: 0;
    
    // Font
    font-family: var(--headerFont);
    font-style: normal;
    font-weight: bold;
    font-size: var(--font-2);
    line-height: 1.25;
    text-align: center;
    
    // Color
    color: var(--textWhite)
  };
`;


const LinkWrapper = styled.div`

  // Margin & Padding
  margin: var(--spacer-2) auto;
  padding: 0 0 0 0;
  
  // Flexbox
  display: flex;
  flex-direction: column;
  justify-content: center;
`;


const Title = styled.h2`

  // Margin & Padding
  margin: 0;
  padding: 0;
  
  width: 100%;
  
  
  
  
  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: 500;
  font-size: var(--font-3);
  line-height: 1.5;
  text-align: center;
  
  // Colors
  color: var(--textBlack);
`;

const Description = styled.h2`

  // Margin & Padding
  margin: 0;
  padding: 0;
  
  
  // Font
  font-family: var(--bodyFont);
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-2);
  line-height: 1.25;
  text-align: center;
  
  
 
  // Colors
  color: var(--textBlack);
`;


export default Notification
